import html2canvas from 'html2canvas';

//ΔVΔVΔ: Convert legend html to canvas layer
// const legendToCanvas = async (width, height) => {
//     var legend = document.getElementById('map-legend');
//     legend.classList.add('match-height');
//     return html2canvas(legend, {
//         scale: window.devicePixelRatio * 2
//     }).then(function (canvas) {
//         canvas.id = 'map-legend-canvas';
//         document.body.appendChild(canvas);
//         legend.classList.remove('match-height');
//         return document.body.querySelector('#map-legend-canvas');
//     });
// };
// const titleToCanvas = async () => {
//     var titleDom = document.querySelector('.printing #title');
//     var titleCopy = html2canvas(titleDom, {
//         scale: window.devicePixelRatio * 2
//     });
//     return titleCopy;
// };

const convertMapToImage = async (mapdom, width, height, includeLegend = true, includeTitle = false) => {
    const mapCanvas = document.createElement('canvas');
    mapCanvas.style.background = 'white';
    mapCanvas.width = width;
    mapCanvas.height = height;

    const mapContext = mapCanvas.getContext('2d');
    mapContext.fillStyle = 'white';
    mapContext.fillRect(0, 0, width, height);

    var mapDom = document.querySelector('.printing');

    document.querySelector('#printCanvas').innerHTML = '';
    document.querySelector('#printCanvas').append(mapCanvas);
    mapDom.style.width = width + 'px';

    //ΔVΔVΔ: Draw each layer onto output canvas
    Array.prototype.forEach.call(mapdom.querySelectorAll('.ol-layer canvas'), function (canvas) {
        if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            // Get the transform parameters from the style's transform matrix
            const matrix = transform
                .match(/^matrix\(([^\(]*)\)$/)[1]
                .split(',')
                .map(Number);
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
            mapContext.drawImage(canvas, 0, 0);
        }
    });

    mapDom.classList.remove('hide-title');
    mapDom.classList.remove('hide-legend');
    if (!includeLegend) {
        mapDom.classList.add('hide-legend');
    }
    if (!includeTitle) {
        mapDom.classList.add('hide-title');
    }
    var mapCopy = await html2canvas(mapDom);

    // ΔVΔVΔ: Convert Canvas to 64 bit image url
    const converted = mapCopy.toDataURL('image/jpeg');
    document.querySelector('#printCanvas').innerHTML = '';
    return converted;
};
export { convertMapToImage };
